<template>
<section class="card profile-seeking">
    <h1>{{ t.seeking.seeking }}</h1>

    <template v-if="editMode">
        <p v-if="localConfig.data.showProfileSeeking">
            <editable :options="seekingOptions" :params="profileParams" property="seeking" type="checkboxes"
                :value="profile.seekingIds" :editable="editMode"></editable>
        </p>

        <table class="table" v-if="editMode">
            <tbody>
            <tr>
                <th>{{ t.stats.age }}</th>
                <td>
                    <editable :params="profileParams" property="seekAttributesAge" type="ageRange"
                        :value="[profile.minAge, profile.maxAge]"></editable>
                </td>
            </tr>
            <template v-if="!extendedPerson">
                <tr>
                    <th>{{ t.seeking.distance }}</th>
                    <td><editable :params="profileParams" property="seekAttributesDistance" type="distance"
                            :value="profile.seekingDistance"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.seeking.smokers }}</th>
                    <td>
                        <editable :options="noDontMind" :params="profileParams" property="seekAttributesNonSmokers" type="select"
                            :value="profile.smoke"></editable>
                    </td>
                </tr>
            </template>
            <template v-if="extendedPerson">
                <tr>
                    <th>{{ t.stats.extended.attitude }}</th>
                    <td><editable :params="profileParams" :options="attitudeOptions" property="attitude" type="checkboxes"
                        :value="profile.attitude"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.build }}</th>
                    <td><editable :options="buildOptions" :params="profileParams" property="seekAttributesBuild" type="checkboxes"
                        :value="profile.build"></editable></td>
                </tr>
                 <tr>
                    <th>{{ t.stats.extended.character_type }}</th>
                    <td><editable :options="characterTypeOptions" :params="profileParams" property="seekAttributesCharacterType" type="checkboxes"
                        :value="profile.characterType"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.seeking.distance }}</th>
                    <td><editable :params="profileParams" property="seekAttributesDistance" type="distance"
                        :value="profile.seekingDistance"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.drink }}</th>
                    <td><editable :params="profileParams" :options="drinkOptions" property="drink" type="checkboxes"
                        :value="profile.drink"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.employment }}</th>
                    <td><editable :options="employmentOptions" :params="profileParams" property="seekAttributesEmployment" type="checkboxes"
                        :value="profile.employment"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.ethnicity }}</th>
                    <td><editable :params="profileParams" :options="ethnicityOptions" property="ethnicity" type="checkboxes"
                        :value="profile.ethnicity"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.hair }}</th>
                    <td><editable :options="hairOptions" :params="profileParams" property="seekAttributesHair" type="checkboxes"
                        :value="profile.hair"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.hair_colour }}</th>
                    <td><editable :options="hairColourOptions" :params="profileParams" property="seekAttributesHairColour" type="checkboxes"
                        :value="profile.hairColour"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.height }}</th>
                    <td><editable :params="profileParams" property="seekAttributesHeight" type="heightRange"
                        :value="[profile.minHeight, profile.maxHeight]"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.materialistic }}</th>
                    <td><editable :options="materialisticOptions" :params="profileParams" property="seekAttributesMaterialistic" type="checkboxes"
                        :value="profile.materialistic"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.personality }}</th>
                    <td><editable :options="personalityOptions" :params="profileParams" property="seekAttributesPersonality" type="checkboxes"
                        :value="profile.personality"></editable></td>
                </tr>
               <tr>
                    <th>{{ t.stats.extended.religion }}</th>
                    <td><editable :options="religionOptions" :params="profileParams" property="seekAttributesReligion" type="checkboxes"
                        :value="profile.religion"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.seeking.smokers }}</th>
                    <td><editable :options="smokeOptions" :params="profileParams" property="seekAttributesNonSmokers" type="select"
                        :value="profile.smoke"></editable>
                    </td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.social_class }}</th>
                    <td><editable :options="socialClassOptions" :params="profileParams" property="seekAttributesSocialClass" type="checkboxes"
                        :value="profile.socialClass"></editable></td>
                </tr>
                <tr>
                    <th>{{ t.stats.extended.transport }}</th>
                    <td><editable :params="profileParams" :options="transportOptions" property="transport" type="checkboxes"
                        :value="profile.transport"></editable></td>
                </tr>
            </template>
            </tbody>
        </table>
    </template>
    <template v-else>
        <p v-if="!profile.seeking">{{ t.seeking.not_seeking }}</p>
        <ul v-else class="list-unstyled">
            <li v-for="(seek, index) in profile.seeking" :key="index">{{ seek }}</li>
        </ul>
    </template>
</section>
</template>

<script>
import Editable from 'Site/component/Editable.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileSeeking',
    components: {
        Editable
    },
    computed: {
        ...mapState({
            config: state => state.config.data
        }),
        extendedPerson() { return this.localConfig.data.extendedPerson; },
        profileParams() { return { id: this.config.userId, url: 'profile' }; },
        seekingOptions() { return this.localConfig.data.seeking; }
    },
    data() {
        const data = {
            noDontMind: [
                { value: '1', text: this.t.user_view.no },
                { value: '', text: this.t.user_view.dontmind }
            ],
        };

        if (this.localConfig.data.extendedPerson) {
            data.attitudeOptions = this.localConfig.data.formOptions.attitude;
            data.behaviourOptions = this.localConfig.data.formOptions.behaviour;
            data.buildOptions = this.localConfig.data.formOptions.build;
            data.characterTypeOptions = this.localConfig.data.formOptions.characterType;
            data.drinkOptions = this.localConfig.data.formOptions.drink;
            data.employmentOptions = this.localConfig.data.formOptions.employment;
            data.ethnicityOptions = this.localConfig.data.formOptions.ethnicity;
            data.hairOptions = this.localConfig.data.formOptions.hair;
            data.hairColourOptions = this.localConfig.data.formOptions.hairColour;
            data.materialisticOptions = this.localConfig.data.formOptions.materialistic;
            data.personalityOptions = this.localConfig.data.formOptions.personality;
            data.relationshipOptions = this.localConfig.data.formOptions.relationship;
            data.religionOptions = this.localConfig.data.formOptions.religion;
            data.smokeOptions = this.localConfig.data.formOptions.smoke;
            data.socialClassOptions = this.localConfig.data.formOptions.socialClass;
            data.transportOptions = this.localConfig.data.formOptions.transport;
        }

        return data;
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        localConfig: {
            type: Object,
            required: true
        },
        profile: {
            type: Object,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
